import { render, staticRenderFns } from "./FraudEvidenceView.vue?vue&type=template&id=c9f43df6&scoped=true&"
import script from "./FraudEvidenceView.vue?vue&type=script&lang=js&"
export * from "./FraudEvidenceView.vue?vue&type=script&lang=js&"
import style0 from "./FraudEvidenceView.vue?vue&type=style&index=0&id=c9f43df6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f43df6",
  null
  
)

export default component.exports